module.exports = __webpack_public_path__ + "static/media/serve.1d4fdf48.png";